// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal-card-body[data-v-0929483e]{flex-direction:column}.button[data-v-0929483e]{margin-right:.5rem}@media (-ms-high-contrast:active),(-ms-high-contrast:none){.modal-card[data-v-0929483e]{height:40rem!important}}@media only screen and (max-width:769px){.modal-card[data-v-0929483e]{width:95%;height:75%}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
